var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5015_17077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 2.6665C12.8868 2.6665 13.3335 3.11317 13.3335 3.6665V12.3332C13.3335 12.8865 12.8868 13.3332 12.3335 13.3332C11.7802 13.3332 11.3335 12.8865 11.3335 12.3332V3.6665C11.3335 3.11317 11.7802 2.6665 12.3335 2.6665ZM4.3335 9.33317C4.88683 9.33317 5.3335 9.77984 5.3335 10.3332V12.3332C5.3335 12.8865 4.88683 13.3332 4.3335 13.3332C3.78016 13.3332 3.3335 12.8865 3.3335 12.3332V10.3332C3.3335 9.77984 3.78016 9.33317 4.3335 9.33317ZM8.3335 5.99984C8.88683 5.99984 9.3335 6.4465 9.3335 6.99984V12.3332C9.3335 12.8865 8.88683 13.3332 8.3335 13.3332C7.78016 13.3332 7.3335 12.8865 7.3335 12.3332V6.99984C7.3335 6.4465 7.78016 5.99984 8.3335 5.99984Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5015_17077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/Wifi.c5c2fbdd6b223889f8af848db87e6148.svg";
export { ForwardRef as ReactComponent };